import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';

import * as Sentry from '@sentry/react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from 'shared/util/localization';
import ErrorBoundary from 'shared/components/errorBoundary/errorBoundary';
import WithErrorHandler from 'hoc/withErrorHandler/withErrorHandler';

import App from './app';
import { UserProvider } from 'shared/components/userContext/userContext';
import { QueryParamsProvider } from 'shared/components/userContext/queryParamContext';

const Root: React.FC = () => {
	return (
		<I18nextProvider i18n={i18n}>
			<BrowserRouter>
				<QueryParamsProvider>
					<UserProvider>
						<WithErrorHandler />
						<ErrorBoundary>
							<App />
						</ErrorBoundary>
					</UserProvider>
				</QueryParamsProvider>
			</BrowserRouter>
		</I18nextProvider>
	);
};

export default Root;
